import { toast } from 'react-hot-toast';
import { useRef, useState } from 'react';
import { useUser } from '../hooks/useUser';
import { addEvent } from '../services/fetch-utils';
import { formatDateTime } from '../services/formatTime';
import { AddEventObj } from '../interfaces/fetchUtilsInterface';
// import { updateUserEventsListAfterAction } from '../context/UserProvider';
interface CreateEventFormProps {
  eventDate?: Date;
}

export const CreateEventForm: React.FC<CreateEventFormProps> = ({ eventDate }) => {
  const { user, updateUserEventsListAfterAction } = useUser();
  const formRef = useRef<HTMLFormElement>(null);

  const [eventName, setEventName] = useState('');
  const [time, setTime] = useState('00:00');
  const [address, setAddress] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [zipCode, setZipCode] = useState('');

  const resetForm = () => {
    setEventName('');
    setTime('00:00');
    setAddress('');
    setCity('');
    setState('');
    setZipCode('');
    formRef.current?.reset();
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // Build address inline — no intermediate state or useEffect needed
    const event: AddEventObj = {
      eventName,
      date: eventDate!,
      time,
      address: { address, city, state, zipCode },
      user_id: user?.user_id || '',
    };

    toast
      .promise(addEvent(event), {
        loading: 'Uploading your event…',
        success: `Event created for ${eventDate?.toDateString()}`,
        error: 'Something went wrong. Please try again.',
      })
      .then((res) => {
        console.log('RES IN CREATE FORM', res);
        if (res.status === 201 && user) {
          updateUserEventsListAfterAction(user?.user_id);
        }
      });

    resetForm();
  };

  const previewTime = formatDateTime(eventDate ?? new Date(), time);

  return (
    <form
      ref={formRef}
      onSubmit={handleSubmit}
      style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}
    >
      <label>
        Event name
        <input
          type="text"
          placeholder={`e.g. ${user?.username}'s Show`}
          value={eventName}
          onChange={(e) => setEventName(e.target.value)}
          required
        />
      </label>

      <label>
        Address
        <input type="text" value={address} onChange={(e) => setAddress(e.target.value)} />
      </label>
      <label>
        City
        <input type="text" value={city} onChange={(e) => setCity(e.target.value)} />
      </label>
      <label>
        State
        <input type="text" value={state} onChange={(e) => setState(e.target.value)} />
      </label>
      <label>
        Zip code
        <input type="text" value={zipCode} onChange={(e) => setZipCode(e.target.value)} />
      </label>

      <label>
        Start time
        <input type="time" value={time} onChange={(e) => setTime(e.target.value)} />
      </label>

      <p style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>
        Schedule for: {previewTime}
      </p>

      <button type="submit" className="btn-primary">
        Schedule Event
      </button>
    </form>
  );
};
